module.exports = __webpack_public_path__ + "img/project1_5.png.c3a00ed1.webp";